<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Due Date"
    >
      <b-input-group>
        <flat-pickr
          id="secondDate"
          v-model="dueDateValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group
      label="Status"
      @click.native.stop
    >
      <v-select
        v-model="statusValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="title"
        placeholder="Select an option"
        :options="statusDataOptions"
        :clearable="false"
        :reduce="title => title.code"
      />
    </b-form-group>
    <b-form-group
      label="Request Type"
      @click.native.stop
    >
      <v-select
        v-model="requestTypeValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select an option"
        :options="requestTypeOptions"
        :selectable="option => !option.hasOwnProperty('category')"
        :clearable="false"
        :reduce="name => name._id"
      >
        <template #option="{ category, name, }">
          <div
            v-if="category"
            class="group"
          >
            {{ category }}
          </div>
          {{ name }}
        </template>
      </v-select>
    </b-form-group>
    <b-form-group
      label="Assignee"
      @click.native.stop
    >
      <v-select
        v-model="assigneeValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select an option"
        :options="assigneeOptions"
        :clearable="false"
        :reduce="name => name._id"
      />
    </b-form-group>
    <div class="button__action">
      <b-button
        variant="outline-primary"
        size="sm"
        class="mr-1"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    flatPickr,
    vSelect,
  },
  props: {
    status: {
      type: [String, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null,
    },
    dueDate: {
      type: [String, null],
      default: null,
    },
    statusDataOptions: {
      type: Array,
      required: true,
    },
    requestType: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    requestTypeOptions: {
      type: Array,
      required: true,
    },
    assignee: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    assigneeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dueDateValue: this.dueDate,
      statusValue: this.status,
      requestTypeValue: JSON.parse(JSON.stringify(this.requestType)) || [],
      assigneeValue: JSON.parse(JSON.stringify(this.assignee)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    dueDate: {
      immediate: true,
      handler(val) {
        this.dueDateValue = val
      },
    },
    status: {
      immediate: true,
      handler(val) {
        this.statusValue = val
      },
    },
    requestType: {
      immediate: true,
      handler(val) {
        this.requestTypeValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    assignee: {
      immediate: true,
      handler(val) {
        this.assigneeValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.dueDateValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:dueDate', this.dueDateValue)
      this.$emit('update:status', this.statusValue)
      this.$emit('update:requestType', this.requestTypeValue)
      this.$emit('update:assignee', this.assigneeValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.dueDateValue = ''
      this.statusValue = ''
      this.requestTypeValue = []
      this.assigneeValue = []
      this.$emit('update:dueDate', this.dueDateValue)
      this.$emit('update:status', this.statusValue)
      this.$emit('update:requestType', this.requestTypeValue)
      this.$emit('update:assignee', this.assigneeValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
